import React from 'react';
import { useLang } from '../../i18n/LangContext';

const nums = ["01","02","03","04","05","06","07"];

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how-it-works" className="bg-[#0B0D0F] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{t.howItWorks.label}</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-3 font-outfit">{t.howItWorks.heading}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.howItWorks.steps.slice(0, 4).map((step, i) => (
            <div key={i} className="relative">
              <div className="bg-[#12151A] rounded-lg border border-white/8 p-6 h-full">
                <span className="text-[#D4AF37] text-3xl font-bold font-mono opacity-30">{nums[i]}</span>
                <h3 className="text-white font-semibold mt-3 mb-2 font-outfit text-sm">{step.name}</h3>
                <p className="text-slate-400 text-xs leading-relaxed">{step.desc}</p>
              </div>
              {i < 3 && <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-[#D4AF37]/30" />}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
          {t.howItWorks.steps.slice(4).map((step, i) => (
            <div key={i} className="bg-[#12151A] rounded-lg border border-white/8 p-6">
              <span className="text-[#D4AF37] text-3xl font-bold font-mono opacity-30">{nums[i + 4]}</span>
              <h3 className="text-white font-semibold mt-3 mb-2 font-outfit text-sm">{step.name}</h3>
              <p className="text-slate-400 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
